module.exports = __webpack_public_path__ + "dd771162c4f3170585a4efa5b252a1fa.png";